import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Box, Text, CircularProgress } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { SessionForm, Button } from '../';
import { createSession, setEditSession, Modals, closeModal, openModal } from '../../redux/reducers';
import SessionCreatedModal from '../common/modal/sessionCreatedModal';

const CreateSession = ({ editSession, ...containerProps }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { savingSession, sessionSaveError } = useSelector((state) => state.session);
  const [createdSession, setCreatedSession] = useState({ valid: false });
  const [newSession, setNewSession] = useState({});
  const { showModal, modalProps, modalName } = useSelector((state) => state.ui);
  const doCreateSession = (data) => {
    dispatch(createSession(data)).then((result) => {
      if (result != null) {
        setNewSession(result);
        dispatch(openModal({}, Modals.SESSION_CREATED));
        // clear after creation
        dispatch(setEditSession(null));
      }
    });
  };

  useEffect(() => {
    if (sessionSaveError != null && modalName === null) {
      dispatch(
        openModal(
          {
            headerText: t('modal.error'),
            bodyText: `${t('interpreter.form.createError')}: ${sessionSaveError?.message}`,
          },
          Modals.ERROR
        )
      );
    }
  }, [sessionSaveError]);

  return (
    <>
      <SessionCreatedModal
        open={showModal && modalName === Modals.SESSION_CREATED}
        session={newSession}
        onRightButtonClick={() => dispatch(closeModal())}
        leftButtonText={null}
        {...modalProps}
      />
      <Box pt={6} px={4} bg="brand.100" {...containerProps}>
        <Text mb={2} fontSize="2xl" fontWeight="bold">
          {t('interpreter.createNewSessionTitle')}
        </Text>
        <SessionForm
          editSession={editSession}
          onChanged={(createdSession) => setCreatedSession(createdSession)}
        />
        <Button
          bg="brand.60"
          color="white"
          my={6}
          isDisabled={createdSession.valid === false}
          onClick={() => doCreateSession(createdSession.data)}
        >
          {savingSession === false && t('interpreter.form.createNewSession')}
          {savingSession === true && <CircularProgress mx={4} isIndeterminate size={25} />}
        </Button>
      </Box>
    </>
  );
};

CreateSession.propTypes = {
  editSession: PropTypes.object.isRequired,
};

export default CreateSession;
